import Hero from "./Hero"
import Footer from "./Footer";

export default function Home() {
    return (
      <div>
  

        <Hero/>
        {/* CTA Banner */}
        <section className="relative py-20 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 bg-emerald-50">
            <div className="absolute inset-0" style={{
            }} />
          </div>

          <div className="container mx-auto px-4 relative">
            <div className="flex flex-col lg:flex-row items-start justify-between gap-12">
              <div className="lg:w-1/2">
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 text-left">
                  Ready to Experience Premium Ethiopian Agriculture?
                </h2>
                <p className="text-lg text-gray-600 mb-8 text-left">
                  Join us in bringing the finest Ethiopian agricultural products to the global market. From premium coffee beans to quality cereals and pulses, we ensure excellence in every product.
                </p>
                <div className="flex flex-wrap gap-4">
                
                  <a href="/product" className="inline-flex items-center px-8 py-4 border-2 border-emerald-600 text-emerald-600 rounded-full text-lg font-semibold hover:bg-emerald-600 hover:text-white transition-colors duration-300">
                    View Products
                  </a>
                </div>
              </div>
              
              <div className="lg:w-1/2">
                <div className="relative">
                  <div className="grid grid-cols-2 gap-6">
                    <div className="relative transform hover:-translate-y-2 transition-transform duration-300 hover:z-10" style={{marginTop: "-20px", marginLeft: "10px"}}>
                      <div className="absolute -inset-2 bg-emerald-500/20 rounded-xl blur-lg"></div>
                      <img 
                        src="/assets/images/products/Mung-Beans.jpg"
                        alt="Mung Beans"
                        className="relative rounded-xl shadow-xl w-full h-48 object-cover border-4 border-white"
                      />
                    </div>
                    <div className="relative transform hover:-translate-y-2 transition-transform duration-300 hover:z-10" style={{marginTop: "20px", marginLeft: "-10px"}}>
                      <div className="absolute -inset-2 bg-emerald-500/20 rounded-xl blur-lg"></div>
                      <img 
                        src="/assets/images/products/coffee.jpg" 
                        alt="Ethiopian Coffee" 
                        className="relative rounded-xl shadow-xl w-full h-48 object-cover border-4 border-white"
                      />
                    </div>
                    <div className="relative transform hover:-translate-y-2 transition-transform duration-300 hover:z-10" style={{marginTop: "-10px", marginLeft: "-20px"}}>
                      <div className="absolute -inset-2 bg-emerald-500/20 rounded-xl blur-lg"></div>
                      <img 
                        src="/assets/images/others/lanscape.jpg" 
                        alt="Coffee Farm" 
                        className="relative rounded-xl shadow-xl w-full h-48 object-cover border-4 border-white"
                      />
                    </div>
                    <div className="relative transform hover:-translate-y-2 transition-transform duration-300 hover:z-10" style={{marginTop: "30px"}}>
                      <div className="absolute -inset-2 bg-emerald-500/20 rounded-xl blur-lg"></div>
                      <img 
                        src="/assets/images/products/Berbere.jpeg" 
                        alt="Coffee Beans" 
                        className="relative rounded-xl shadow-xl w-full h-48 object-cover border-4 border-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>



        <Footer />
      </div>
    );
  }